module.exports = __webpack_public_path__ + "img/SH.0ae120ba.png";